export default __webpack_public_path__ + "media/images/datetime-chooser-sprite-4909061ae8ddba867c3c817ef0a2bc91.png";